import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Button, Card, Modal, Spin, Col, Row } from 'antd';
import { queries } from '../../graphql/graphql';
const { Meta } = Card;

export const FindConfigurator = props => {
  const { decorId, setUrl, id, url } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data = {}, loading } = useQuery(queries.FIND_CONFIGURATOR, {
    variables: { decorId, id }
  });
  const { findConfigurator } = data;

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onAdd = id => {
    setUrl(`https://3d.homewip.com/#!/configurator/${id}`);
    setIsModalOpen(false);
  };

  const getDate = str => {
    const date = new Date(str);
    const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(date.getDate()).padStart(2, '0')}`;
    const formattedTime = `${String(date.getHours()).padStart(2, '0')}:${String(
      date.getMinutes()
    ).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;

    return `${formattedDate} ${formattedTime}`;
  };

  return (
    <>
      <Button type="primary" onClick={showModal}>
        Find Configurators
      </Button>
      <Modal title="Configurators" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        {loading ? (
          <Spin />
        ) : (
          <Row gutter={[16, 16]}>
            {findConfigurator &&
              findConfigurator.configurators &&
              findConfigurator.configurators.length &&
              findConfigurator.configurators.map(
                configurator =>
                  configurator.product && (
                    <Col key={configurator._id} lg={12}>
                      <Card
                        style={{
                          border:
                            url.indexOf(`${configurator.product}`) > 0
                              ? '2px solid green'
                              : '1px solid #f0f0f0'
                        }}
                        hoverable
                        actions={[
                          <Button
                            key="model-view"
                            type="link"
                            onClick={() =>
                              window.open(
                                `https://3d.homewip.com/#!/configurator/${configurator.product}`
                              )
                            }
                          >
                            View
                          </Button>,
                          <Button
                            key="model-product"
                            type="link"
                            onClick={() =>
                              window.open(
                                `https://3d.homewip.com/#!/product/${configurator.product}`
                              )
                            }
                          >
                            Product
                          </Button>,
                          <Button
                            key="model-add"
                            type="primary"
                            onClick={() => onAdd(configurator.product)}
                          >
                            Add
                          </Button>
                        ]}
                      >
                        <Meta
                          title={configurator.name}
                          description={
                            <>
                              <p>Created at: {getDate(configurator.createdAt)}</p>
                            </>
                          }
                        />
                      </Card>
                    </Col>
                  )
              )}
          </Row>
        )}
      </Modal>
    </>
  );
};
